import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { XpoAuthenticationService } from '@xpo-ltl/ngx-auth';
import { take } from 'rxjs/operators';
import { AppRoutes } from '../../../enums/app-routes.enum';

@Component({
  selector: 'app-auth-redirect',
  template: '',
})
export class AuthRedirectComponent implements OnInit {
  constructor(private router: Router, private xpoAuthService: XpoAuthenticationService) {}

  ngOnInit(): void {
    this.xpoAuthService.isLoggedIn$.pipe(take(1)).subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        this.router.navigate([AppRoutes.DYNAMIC_RULE, AppRoutes.LIST_PAGE]);
      } else {
        this.router.navigate([AppRoutes.NOT_AUTHORIZED_PAGE]);
      }
    });
  }
}
